module.exports = __webpack_public_path__ + "static/media/Japan_Croatia.00510fa0.jpeg";